export default {
  "about": "O nama",
  "about_title": "O nama",
  "access_secret": "Pristupna tajna",
  "access_token": "Pristupni token",
  "accessibility_animations": "Animacije",
  "accessibility_contrast": "Kontrast",
  "accessibility_font_size": "Veličina fonta",
  "accessibility_title": "Pristupačnost",
  "actions": "Radnje",
  "active": "Aktivno",
  "active_ads": "Aktivni oglasi",
  "active_campaigns": "Aktivne kampanje",
  "ad_code_placeholder": "<script>...</script> ili AdSense kod za slot",
  "ad_format": "Format oglasa",
  "ad_formats": "Formati oglasa",
  "ad_management": "Upravljanje oglasima",
  "ad_position_settings": "Postavke pozicija oglasa",
  "ad_price_list": "Cjenik oglasa",
  "ad_pricing_formats_campaigns": "Cijene, formati, kampanje i praćenje",
  "add": "Dodaj",
  "add_api_keys": "Dodaj API ključeve u karticu Konfiguracija",
  "address": "Adresa",
  "admin": "Admin",
  "adminPanel": "Admin panel",
  "admin_ab_testing_title": "A/B testiranje",
  "admin_accent": "Naglasak",
  "admin_accent_color": "Naglašena boja",
  "admin_action": "Akcija",
  "admin_activate": "Aktiviraj",
  "admin_active_feeds": "Aktivni feedovi",
  "admin_active_label": "AKTIVNO",
  "admin_active_now": "Trenutno aktivni",
  "admin_active_subscribers": "Aktivni pretplatnici",
  "admin_ad_performance": "Učinak oglasa",
  "admin_add_feed": "Dodaj feed",
  "admin_add_tag": "Dodaj oznaku",
  "admin_admins": "Administratori",
  "admin_advertisements": "Oglasi",
  "admin_advertiser_email": "E-mail oglašivača",
  "admin_advertiser_name": "Ime oglašivača",
  "admin_affiliate_links": "Partnerske poveznice",
  "admin_ai_content_title": "Obrada AI sadržaja",
  "admin_ai_prompt_settings": "AI Podešavanje i Model Postavke",
  "admin_analytics_title": "Analitika",
  "admin_api_latency": "API latencija",
  "admin_api_server": "API poslužitelj",
  "admin_article_actions": "Akcije",
  "admin_article_category": "Kategorija",
  "admin_article_published": "Objavljeno",
  "admin_article_selector": "Selektor članka (CSS, npr. article.news)",
  "admin_article_views": "Pregledi",
  "admin_articles_count": "Članci",
  "admin_articles_title": "Članci",
  "admin_author_change_failed": "Promjena autora nije uspjela.",
  "admin_authors_title": "Autori",
  "admin_auto": "AUTO",
  "admin_auto_save_draft": "Automatska pohrana kao skica",
  "admin_avg_seo_score": "Prosječna SEO ocjena",
  "admin_bio": "Biografija",
  "admin_blog_manage": "Upravljaj blog objavama s uređivačem bogatog sadržaja",
  "admin_blog_title": "Blog",
  "admin_brand_theme": "Marka i Tema",
  "admin_branding_desc": "Prilagodite izgled stranice (samo za sistemske administratore)",
  "admin_branding_title": "Modul za rebrendiranje",
  "admin_breaking_ticker": "Tiker vijesti",
  "admin_browser": "Preglednik",
  "admin_browsers": "Preglednici",
  "admin_bug_reports": "Izvještaji o greškama",
  "admin_bulk_delete_failed": "Masovno brisanje nije uspjelo.",
  "admin_bulk_operations": "Masovne operacije",
  "admin_categories_grid": "Mreža kategorija",
  "admin_choose_gallery": "Odaberi iz galerije",
  "admin_churn_prediction": "Prognoza odljeva",
  "admin_classic_portal": "Klasični portal vijesti",
  "admin_classifieds": "Mali oglasi",
  "admin_clear_log": "Očisti zapisnik",
  "admin_click_button": "Klikni gumb",
  "admin_collection_stats": "Statistika kolekcije",
  "admin_color_scheme": "Shema boja",
  "admin_columnist": "Kolumnist",
  "admin_comments": "Komentari",
  "admin_competitor_monitoring": "Praćenje konkurenata",
  "admin_confirm_action": "Jeste li sigurni?",
  "admin_content_calendar_title": "Kalendar sadržaja",
  "admin_content_filter": "Uvjeti filtra sadržaja",
  "admin_content_stats": "Statistike sadržaja",
  "admin_contributor": "Suradnik",
  "admin_coordinates": "Koordinate",
  "admin_copy_ip": "Kopiraj IP adresu",
  "admin_copy_text": "Kopiraj",
  "admin_core_services": "Osnovne usluge",
  "admin_countries": "Države",
  "admin_cpc": "CPC (EUR)",
  "admin_crawl_now": "Pregledaj sada",
  "admin_create_author": "Kreiraj autora",
  "admin_create_manage_promo": "Kreiraj i upravljaj promotivnim kodovima",
  "admin_create_voucher": "Kreiraj vaučer",
  "admin_custom_meta": "Prilagođeni meta",
  "admin_dashboard_title": "Nadzorna ploča",
  "admin_database": "Baza podataka",
  "admin_db_backup": "Sigurnosna kopija baze podataka",
  "admin_db_latency": "DB latencija",
  "admin_db_name": "Naziv baze podataka",
  "admin_db_size": "Veličina DB-a",
  "admin_default": "ZADANO",
  "admin_default_language": "Zadani jezik",
  "admin_device": "Uređaj",
  "admin_devices": "Uređaji",
  "admin_discount": "Popust",
  "admin_disk_usage": "Upotreba diska",
  "admin_docs_api_ref": "API referenca",
  "admin_docs_download_pdf": "Preuzmi PDF",
  "admin_docs_faq": "Često postavljana pitanja",
  "admin_docs_getting_started": "Početak rada",
  "admin_docs_implemented": "Provedeno",
  "admin_docs_no_pages": "Još nema stranica dokumentacije",
  "admin_docs_order": "Redoslijed",
  "admin_docs_title": "Dokumentacija",
  "admin_doktor_earnings": "Zarada Doktora",
  "admin_draft_articles": "Nacrti članaka",
  "admin_dynamic_pricing": "Dinamičko određivanje cijena",
  "admin_edit_in_cms": "Uredi u CMS-u",
  "admin_editor_role": "Urednik",
  "admin_export_csv": "Izvezi CSV",
  "admin_favicon": "Favicon",
  "admin_feed_crawler": "Pretraga feeda",
  "admin_feed_name": "Naziv feeda",
  "admin_feed_url": "URL feeda",
  "admin_feeds_title": "RSS feedovi",
  "admin_file": "Datoteka",
  "admin_fixed_amount": "Fiksni iznos",
  "admin_frozen": "Zamrznuti",
  "admin_full_name": "Puno ime",
  "admin_general": "Općenito",
  "admin_google_search_console": "Google Search Console",
  "admin_grade": "Ocjena",
  "admin_health_title": "Provjera stanja",
  "admin_high_leads": "Vrijedni kontakti",
  "admin_import_title": "Croatia Times Platforma za uvoz",
  "admin_index_now": "IndexNow",
  "admin_integrations": "Integracije",
  "admin_job_postings": "Oglasi za posao",
  "admin_joined": "Pridruženi",
  "admin_keywords": "Ključne riječi",
  "admin_landing_title": "Odredišne stranice",
  "admin_last_submissions": "Posljednje prijave",
  "admin_live_analytics": "Uživo analitika",
  "admin_live_analytics_title": "Analitika uživo",
  "admin_llm_model": "LLM model",
  "admin_manage_feeds": "Upravljanje feedovima",
  "admin_mass_management": "Masovno upravljanje člancima",
  "admin_max_articles": "Max. članci",
  "admin_media_storage": "Pohrana medija",
  "admin_memory": "Memorija",
  "admin_menu_manager": "Upravitelj izbornika",
  "admin_meta_description": "Meta opis",
  "admin_monetization_title": "Nadzorna ploča za monetizaciju",
  "admin_mysql_db": "MySQL baza podataka",
  "admin_mysql_host": "MySQL host",
  "admin_nav_ab_testing": "A/B testiranje",
  "admin_nav_ads": "Upravljanje oglasima",
  "admin_nav_ads_report": "Izvješće o oglasima",
  "admin_nav_adsense": "Postavke AdSensea",
  "admin_nav_advertise_analytics": "Analitika oglašavanja",
  "admin_nav_advanced_analytics": "Napredna analitika",
  "admin_nav_affiliates": "Partnerski linkovi",
  "admin_nav_ai_content": "Obrada sadržaja uz AI",
  "admin_nav_hero_settings": "Postavke Hero sekcije",
  "admin_nav_amp": "AMP i Google Discover",
  "admin_nav_analytics": "Analitika",
  "admin_nav_analytics_ai": "Analitika i AI",
  "admin_nav_articles": "Članci",
  "admin_nav_audit_log": "Revizijski zapis",
  "admin_nav_authors": "Autori",
  "admin_nav_blog": "Blog",
  "admin_nav_branding": "Rebrendiranje",
  "admin_nav_breaking_news": "Vijesti u prekidu",
  "admin_nav_breaking_expiry": "Istek breaking vijesti",
  "admin_nav_streams": "Upravljanje streamovima",
  "admin_nav_ad_management": "Upravljanje oglasima",
  "admin_nav_bulk_operations": "Skupne operacije",
  "admin_nav_categories": "Kategorije",
  "admin_nav_chat_sessions": "Sesije čavrljanja",
  "admin_nav_churn_prediction": "Predviđanje odlazaka",
  "admin_nav_classifieds": "Oglasi",
  "admin_nav_comments": "Komentari",
  "admin_nav_competitor_monitoring": "Praćenje konkurencije",
  "admin_nav_content": "Sadržaj",
  "admin_nav_content_calendar": "Kalendar sadržaja",
  "admin_nav_county_map": "Karta zupanija",
  "admin_nav_times_brands": "Times Brendovi",
  "admin_nav_crypto": "Kripto widget",
  "admin_nav_dashboard": "Nadzorna ploča",
  "admin_nav_db_backup": "Baza podataka",
  "admin_nav_docs": "Dokumentacija",
  "admin_nav_doktor_earnings": "Zarada Doktora",
  "admin_nav_duplicate_detection": "Detekcija dupliciranja",
  "admin_nav_editorial": "Uredništvo",
  "admin_nav_editorial_workflow": "Uređivački tijek rada",
  "admin_nav_email_campaigns": "Email kampanje",
  "admin_nav_feeds": "RSS izvori",
  "admin_nav_finance": "Financije",
  "admin_nav_health": "Zdravlje sustava",
  "admin_nav_heatmaps": "Toplinska mapa čitanja",
  "admin_nav_visitor_map": "Karta posjetitelja",
  "admin_nav_import": "Uvoz",
  "admin_nav_invoices": "Računi",
  "admin_nav_job_ads": "Oglasi za posao",
  "admin_nav_landing_pages": "Odredišne stranice",
  "admin_nav_live_analytics": "Analitika uživo",
  "admin_nav_management": "Upravljanje",
  "admin_nav_marketing": "Marketing",
  "admin_nav_media": "Mediji",
  "admin_nav_menu_manager": "Upravitelj izbornika",
  "admin_nav_micropayments": "Mikroplaćanja",
  "admin_nav_monetization": "Monetizacija",
  "admin_nav_newsletter": "Newsletter",
  "admin_nav_newsletter_digest": "Sažetak newslettera",
  "admin_nav_pages": "Stranice",
  "admin_nav_imprint": "Impresum - Tim",
  "admin_nav_payments": "Plaćanja",
  "admin_nav_performance_forecast": "Prognoza izvedbe",
  "admin_nav_photo_verification": "Provjera fotografija",
  "admin_nav_portal_toggle": "Upravljanje portalom",
  "admin_nav_portals": "Portali",
  "admin_nav_pricing": "Cjenik",
  "admin_nav_promo_codes": "Promotivni kodovi",
  "admin_nav_push_notifications": "Push obavijesti",
  "admin_nav_quizzes": "Kvizovi",
  "admin_nav_recommendations": "Preporuke sadržaja",
  "admin_nav_reports": "Izvještaji o sadržaju",
  "admin_nav_sanitization": "Sanitacija sadržaja",
  "admin_nav_scheduler": "Raspored sadržaja",
  "admin_nav_security": "Sigurnost",
  "admin_nav_seo_dashboard": "SEO nadzorna ploča",
  "admin_nav_content_health": "Zdravlje sadržaja",
  "admin_nav_seo_distribution": "SEO i distribucija",
  "admin_nav_series": "Serija članaka",
  "admin_nav_settings": "Postavke",
  "admin_nav_social": "Društvene mreže",
  "admin_nav_social_scheduler": "Raspored društvenih mreža",
  "admin_nav_sponsored": "Sponzorirano",
  "admin_nav_sponsored_marketplace": "Sponzorirano tržište",
  "admin_nav_subscriptions": "Pretplate",
  "admin_nav_surveys": "Ankete",
  "admin_nav_syndication": "Syndication API",
  "admin_nav_system": "Sustav",
  "admin_nav_tips": "Savjeti / Donacije",
  "admin_nav_translations": "Prijevodi",
  "admin_nav_llm_usage": "LLM Korištenje",
  "admin_nav_tuzibaba": "Tužibaba prijave",
  "admin_nav_ponuda": "Ponuda generator",
  "admin_nav_footer_partners": "Footer partneri",
  "admin_nav_ugc_review": "Građanski sadržaj",
  "admin_nav_users": "Korisnici",
  "admin_nav_users_subscriptions": "Korisnici i pretplate",
  "admin_nav_versioning": "Povijest verzija",
  "admin_nav_vibeposao": "Times Posao portal",
  "admin_nav_vouchers": "Bonovi / Popusti",
  "admin_nav_widgets": "Widgeti / Katalozi",
  "admin_new_author_name": "Ime novog autora...",
  "admin_new_post": "Nova objava",
  "admin_no_data": "Nema dostupnih podataka",
  "admin_no_icon": "Nema ikone",
  "admin_no_logo": "Nema logotipa",
  "admin_no_pending_reports": "Nema izvještaja na čekanju",
  "admin_no_published_articles": "Nema pronađenih objavljenih članaka",
  "admin_password_field": "Lozinka",
  "admin_performance_forecast": "Prognoza učinka",
  "admin_photo_verification": "Provjera fotografija",
  "admin_plan": "Plan",
  "admin_platform_audit": "Revizija platforme",
  "admin_portal_toggle": "Upravljanje portalom",
  "admin_premium_users": "Premium korisnici",
  "admin_primary": "Primarna",
  "admin_published_articles": "Objavljeni članci",
  "admin_published_today": "Objavljeno danas",
  "admin_quick_actions": "Brze akcije",
  "admin_recent_articles": "Nedavni članci",
  "admin_role_change_failed": "Neuspjelo ažuriranje uloge.",
  "admin_search_placeholder": "Pretraži admin...",
  "admin_secondary": "Sekundarna",
  "admin_seo_desc": "Optimizacija sadržaja, upravljanje GSC i mapom web mjesta",
  "admin_seo_title": "SEO nadzorna ploča",
  "admin_service_requests": "Zahtjevi za uslugu",
  "admin_set_category": "Postavi kategoriju",
  "admin_set_featured": "Postavi kao istaknuto",
  "admin_settings_saved": "Postavke su spremljene",
  "admin_settings_title": "Postavke",
  "admin_short_desc": "Kratki opis",
  "admin_site_identity": "Identitet stranice",
  "admin_site_logo": "Logotip stranice",
  "admin_site_settings": "Postavke stranice",
  "admin_sponsored_marketplace": "Sponzorirano tržište",
  "admin_sponsored_title": "Sponzorirani članci",
  "admin_surveys_title": "Ankete",
  "admin_system_status": "Status sustava",
  "admin_table_header_actions": "Radnje",
  "admin_table_header_date": "Datum",
  "admin_table_header_email": "E-mail",
  "admin_table_header_name": "Ime",
  "admin_table_header_status": "Status",
  "admin_thumbnail_settings_saved": "Postavke sličica spremljene",
  "admin_top_articles_views": "Najčitaniji članci prema pregledima",
  "admin_total_articles": "Ukupan broj članaka",
  "admin_total_users": "Ukupan broj korisnika",
  "admin_total_views": "Ukupan broj pregleda",
  "admin_ugc_review": "Pregled UGC-a",
  "admin_username": "Korisničko ime",
  "admin_users_title": "Korisnici",
  "admin_version_history": "Povijest verzija",
  "admin_view_health_report": "Pregledaj cjeloviti izvještaj o zdravlju",
  "admin_write_new_article": "Napiši novi članak",
  "adsense_client_id": "AdSense ID klijenta",
  "adsense_enable_disable": "Omogućite/onemogućite sve automatizirane oglase",
  "adsense_global_toggle": "Globalni prekidač za AdSense",
  "adsense_script_code": "AdSense skriptni kod",
  "adsense_settings": "AdSense & pozicije oglasa",
  "advertise_contact_sales": "Kontaktirajte prodaju",
  "advertise_get_started": "Počnite",
  "advertise_reach_audience": "Doprijeti do naše publike",
  "advertise_title": "Oglašavajte s nama",
  "advertiser": "Oglašivač",
  "advertiser_analytics": "Analitika oglašivača",
  "advertiser_email": "E-mail oglašivača",
  "advertising": "Oglašavanje",
  "advertising_cookies": "Kolačići za oglašavanje",
  "affiliate_title": "Partnerski program",
  "ago": "prije",
  "ai_image_prompt": "AI upit za sliku",
  "all": "Sve",
  "all_categories": "Sve kategorije",
  "all_jobs": "Svi oglasi",
  "all_rights": "Sva prava pridržana",
  "all_status": "Sva stanja",
  "all_types": "Sve vrste",
  "alpha": "Alfa",
  "alreadyHaveAccount": "Već imate račun?",
  "already_have_account": "Već imate račun?",
  "analytics": "Analitika",
  "analytics_cookies": "Analitički kolačići",
  "api_key": "API ključ",
  "api_secret": "API tajna",
  "applications": "Prijave",
  "apply": "Primijeni",
  "apply_now": "Prijavi se",
  "approve": "Odobri",
  "approved": "Odobreno",
  "archive": "Arhiviraj",
  "archived": "Arhivirano",
  "article_content": "Sadržaj članka",
  "article_title": "Naslov članka...",
  "article_views": "Pregledi",
  "author": "Autor",
  "auto_posting": "Automatsko objavljivanje i društvene integracije",
  "auto_share_articles": "Automatski dijeli objavljene članke na povezanim platformama",
  "avg_ctr": "Prosječni CTR",
  "back": "Natrag",
  "basic": "Osnovni",
  "be_respectful": "Budite poštovani i civilizirani prema drugim korisnicima i temama članaka",
  "beta": "Beta",
  "book_ad": "Rezerviraj oglas",
  "booking_details": "Detalji rezervacije",
  "breaking": "UPRAVO",
  "bug_description": "Opis greške",
  "business": "Gospodarstvo",
  "business_account_id": "ID poslovnog računa",
  "buyer": "Kupac",
  "campaign_details": "Detalji kampanje",
  "campaigns": "Kampanje",
  "cancel": "Odustani",
  "caption": "Opis",
  "categories": "Kategorije",
  "category": "Kategorija",
  "category_distribution": "Distribucija kategorija",
  "category_push_subscribers": "Pretplatnici na push obavijesti prema kategoriji",
  "chatbot_placeholder": "Upišite poruku...",
  "chatbot_send": "Pošalji",
  "chatbot_title": "Pomoćnik za chat",
  "choose_plan": "Odaberite plan",
  "city": "Grad",
  "classifieds": "Oglasnik",
  "classifieds_title": "Oglasi",
  "clear": "Očisti",
  "click_rate": "Stopa klikova",
  "click_url": "URL za klik (odredište)",
  "clicks": "Klikovi",
  "client_id": "ID klijenta",
  "client_secret": "Tajna klijenta",
  "close": "Zatvori",
  "code": "Kod",
  "commenting_rules": "Pravila komentiranja",
  "comments": "Komentari",
  "companies": "Tvrtke",
  "company": "Tvrtka",
  "compose_social_post": "Sastavi društvenu objavu",
  "configure": "Konfiguriraj",
  "configure_position": "Konfigurirajte svaku poziciju s prilagođenom slikom bannera ili kodom oglasa",
  "confirm": "Potvrdi",
  "confirm_delete": "Jeste li sigurni da želite obrisati?",
  "confirm_password": "Potvrdi lozinku",
  "congratulations": "Čestitke",
  "contact": "Kontakt",
  "contact_title": "Kontakt",
  "contact_us": "Kontaktirajte nas",
  "content": "Sadržaj",
  "cookies": "Kolačići",
  "cookies_title": "Pravila o kolačićima",
  "copy": "Kopiraj",
  "copyright": "Autorska prava",
  "copyright_notice": "Autorska prava",
  "count": "Broj",
  "country": "Država",
  "cpm": "CPM",
  "create": "Stvori",
  "create_first_ad": "Kreirajte svoj prvi oglas",
  "crypto_change_24h": "Promjena u 24h",
  "crypto_market_cap": "Tržišna kapitalizacija",
  "crypto_price": "Cijena",
  "crypto_widget_title": "Kripto",
  "ctr": "CTR",
  "culture": "Kultura",
  "current_plan": "Trenutni plan",
  "custom_ad_code": "Prilagođeni kod oglasa",
  "custom_banner_url": "Prilagođena URL adresa bannera",
  "custom_range": "Prilagođeni raspon",
  "daily_budget": "Dnevni proračun",
  "daily_performance": "Dnevna izvedba",
  "dark_mode": "Tamni način",
  "data_viz_title": "Vizualizacija podataka",
  "date": "Datum",
  "dating_add_video": "Dodajte kratki video kako bi vas potencijalni partneri bolje upoznali",
  "dating_block": "Blokiraj",
  "dating_boosts": "Poboljšanja",
  "dating_city": "Grad",
  "dating_next": "Sljedeće",
  "dating_personality_quiz": "Kviz osobnosti",
  "dating_quiz_completed": "Kviz osobnosti završen",
  "dating_users": "Korisnici",
  "dating_verify_identity": "Potvrdite da ste stvarna osoba",
  "dating_voice_message": "Glasovna poruka",
  "days": "dani",
  "delete": "Izbriši",
  "delete_failed": "Brisanje nije uspjelo.",
  "deleted_successfully": "Uspješno obrisano",
  "deprecated": "Zastarjelo",
  "describe_thumbnail": "Opišite sličicu kako biste generirali...",
  "description": "Opis",
  "deselect_all": "Poništi odabir svih",
  "desktop": "Stolno računalo",
  "details": "Detalji",
  "dimensions": "Dimenzije",
  "disabled": "Onemogućeno",
  "dismiss": "Ukloni",
  "documentation": "Dokumentacija",
  "doktor_add_document": "Dodaj dokument",
  "doktor_biography": "Biografija",
  "doktor_birth_date": "Datum rođenja",
  "doktor_chat": "Chat",
  "doktor_control_date": "Datum kontrole",
  "doktor_date": "Datum",
  "doktor_diagnosis": "Dijagnoza",
  "doktor_enter_name_specialization": "Unesite ime i barem jednu specijalizaciju",
  "doktor_enter_patient_name": "Unesite ime pacijenta",
  "doktor_license_number": "Broj licence",
  "doktor_panel": "Panel doktora",
  "doktor_patient_name": "Ime pacijenta",
  "doktor_text_min_chars": "Tekst mora imati najmanje 50 znakova",
  "doktor_waiting_room": "Čekaonica",
  "dont_have_account": "Nemate račun?",
  "download": "Preuzmi",
  "draft": "Nacrt",
  "duplicate": "Dupliciraj",
  "duration_days": "Trajanje (dani)",
  "economy": "Ekonomija",
  "edit": "Uredi",
  "electronics": "Elektronika",
  "email": "E-mail",
  "email_address": "Email adresa",
  "email_campaigns": "E-mail kampanje",
  "email_clicks": "Klikovi u emailu",
  "email_content": "Sadržaj e-maila...",
  "email_opens": "Otvaranja emailova",
  "email_placeholder": "Vaša email adresa",
  "email_subject": "Predmet e-maila",
  "employer": "Poslodavac",
  "enabled": "Omogućeno",
  "end_date": "Datum završetka",
  "enter_advertiser_email": "Unesite svoj e-mail oglašivača...",
  "enter_email_to_view": "Unesite svoj e-mail oglašivača iznad za pregled učinka kampanje",
  "entertainment": "Zabava",
  "error": "Greška",
  "error_deleting": "Pogreška pri brisanju",
  "error_generating_digest": "Pogreška pri generiranju sažetka",
  "error_loading": "Pogreška pri učitavanju",
  "error_saving": "Pogreška pri spremanju",
  "error_saving_settings": "Pogreška pri spremanju",
  "error_sending": "Pogreška pri slanju",
  "error_uploading": "Pogreška pri prijenosu",
  "error_uploading_photo": "Neuspješno učitavanje fotografije",
  "events_calendar": "Kalendar događanja",
  "excerpt_summary": "Izvod / Sažetak",
  "experimental": "Eksperimentalno",
  "export": "Izvezi",
  "export_data": "Izvoz podataka",
  "facebook": "Facebook",
  "facebook_login_unavailable": "Prijava putem Facebooka nije dostupna",
  "failed_post_comment": "Neuspjelo objavljivanje komentara.",
  "feature_flags": "Značajke opcija",
  "feature_job": "Istakni oglas za posao",
  "featured": "Istaknuto",
  "featured_article": "Istaknuti članak",
  "featured_duration": "Trajanje isticanja",
  "featured_image": "Istaknuta slika",
  "featured_jobs": "Istaknuti oglasi",
  "feedback": "Povratne informacije",
  "filter": "Filtriraj",
  "filter_terms_saved": "Uvjeti filtriranja su spremljeni!",
  "find_jobs": "Pronađi posao",
  "first": "Prva",
  "first_process_publish": "Prvo obradite i objavite članak",
  "footer_ai": "Ovaj portal koristi AI pomoć za poboljšanje korisničkog iskustva",
  "footer_ai_notice": "Neki sadržaji stvoreni uz pomoć AI - prijavite probleme",
  "footer_cat_business": "Biznis",
  "footer_cat_culture": "Kultura",
  "footer_cat_health": "Zdravlje",
  "footer_cat_news": "Vijesti",
  "footer_cat_politics": "Politika",
  "footer_cat_sports": "Sport",
  "footer_cat_technology": "Tehnologija",
  "footer_categories": "Kategorije",
  "footer_copyright": "2026 Liber Nostra d.o.o. Sva prava pridržana.",
  "footer_description": "Croatia Times je vaš pouzdani izvor za najnovije vijesti, dubinske analize i zanimljive priče iz Hrvatske i šire.",
  "footer_developed_by": "Razvijeno i održavano s ljubavlju od",
  "footer_email_placeholder": "Vaša email adresa",
  "footer_here": "ovdje",
  "footer_hosted_by": "Hostirano od",
  "footer_link_about": "O nama",
  "footer_link_advertise": "Oglašavanje",
  "footer_link_contact": "Kontakt",
  "footer_link_cookies": "Kolačići",
  "footer_link_imprint": "Impresum",
  "footer_link_privacy": "Pravila o privatnosti",
  "footer_link_submit_news": "Pošalji vijest",
  "footer_newsletter_text": "Pretplatite se na naš newsletter",
  "footer_quick_links": "Brzi linkovi",
  "footer_stay_informed": "Ostanite informirani",
  "footer_subscribe": "Pretplatiti se",
  "for_you_personalized": "Personalizirani sadržaj temeljen na vašim interesima",
  "for_you_title": "Za Vas",
  "forgot_password": "Zaboravili ste lozinku?",
  "free": "Besplatno",
  "free_plan": "Besplatno",
  "from": "Od",
  "full_time": "Puno radno vrijeme",
  "general": "Općenito",
  "goodbye": "Doviđenja",
  "hashtags": "Hashtage",
  "hashtags_placeholder": "#vijesti #hrvatska...",
  "header_auto_schedule_active": "Automatsko raspoređivanje aktivno",
  "header_forecast": "Prognoza",
  "header_humidity": "Vlažnost",
  "header_live": "UŽIVO",
  "header_portals_label": "Portali",
  "header_weather_humidity": "Vlažnost",
  "header_weather_wind": "Vjetar",
  "header_wind": "Vjetar",
  "health": "Zdravlje",
  "hello": "Zdravo",
  "help": "Pomoć",
  "home": "Početna",
  "home_podcast_title": "Tjedni Pregled Tehnologije: AI u Hrvatskim Start-upovima",
  "home_video_title": "Unutar Zagreba: Dokumentarac o Uličnom Umjetnosti",
  "hours": "sati",
  "import": "Uvezi",
  "impressions": "Prikazi",
  "imprint": "Impresum",
  "imprint_title": "Impresum",
  "inactive": "Neaktivno",
  "info": "Informacije",
  "instagram": "Instagram",
  "invalid_code": "Neispravan kod. Pokušajte ponovno.",
  "items_selected": "odabrane stavke",
  "job_categories": "Kategorije poslova",
  "job_postings": "Objave poslova",
  "job_seeker": "Tražitelj posla",
  "jobs": "Poslovi",
  "just_now": "Upravo sada",
  "language": "Jezik",
  "last": "Zadnja",
  "latest_news": "Najnovije vijesti",
  "legal": "Pravno",
  "lifestyle": "Životni stil",
  "lifetime": "Doživotno",
  "light_mode": "Svijetli način",
  "linked_email_campaign": "Povezano s e-mail kampanjom",
  "linkedin": "LinkedIn",
  "live_stream": "Prijenos uživo",
  "load_more": "Učitaj više",
  "loading": "Učitavanje...",
  "local": "Lokalno",
  "location": "Lokacija",
  "login": "Prijava",
  "logout": "Odjava",
  "loyalty_available_points": "Dostupni bodovi",
  "loyalty_available_rewards": "Dostupne nagrade",
  "loyalty_badges": "Značke",
  "loyalty_consecutive_days": "Uzastopni dani",
  "loyalty_error": "Pogreška",
  "loyalty_leaderboard": "Poredak",
  "loyalty_leaderboard_empty": "Poredak je prazan",
  "loyalty_rewards": "Nagrade",
  "loyalty_used_rewards": "Iskorištene nagrade",
  "majstor_categories": "Kategorije",
  "majstor_city": "Grad",
  "majstor_company_name": "Naziv tvrtke *",
  "majstor_flexible": "Fleksibilno",
  "majstor_max_budget": "Maksimalni proračun (EUR)",
  "majstor_min_budget": "Minimalni proračun (EUR)",
  "majstor_my_requests": "Moji zahtjevi",
  "majstor_request_title": "Naslov zahtjeva *",
  "majstor_service_categories": "Kategorije usluga",
  "majstor_urgent": "Hitno",
  "manage": "Upravljaj",
  "manage_bookings": "Upravljajte rezervacijama oglašivača",
  "mark_as_read": "Označi kao pročitano",
  "marketing_dashboard": "Nadzorna ploča za marketing",
  "marketing_live_metrics": "Metrički podaci uživo za Croatia Times",
  "marketing_published_articles": "Objavljeni članci",
  "marketing_registered_users": "Registrirani korisnici",
  "marketing_today_views": "Današnji pregledi",
  "marketing_total_views": "Ukupno pregleda stranica",
  "minutes": "minute",
  "missing_translations": "Nedostajući prijevodi",
  "mobile": "Mobitel",
  "more": "Više",
  "most_popular": "Najpopularniji",
  "most_read": "Najčitanije",
  "move": "Premjesti",
  "must_be_logged_in_purchase": "Morate biti prijavljeni da biste kupili članak",
  "myProfile": "Moj profil",
  "my_applications": "Moje prijave",
  "name": "Ime",
  "new": "Novo",
  "new_article": "Novi članak",
  "new_campaign": "Nova kampanja",
  "new_notification": "Nova obavijest",
  "new_push_notification": "Nova push obavijest",
  "new_verification_sent": "Novi verifikacijski kod poslan je na vašu e-mail adresu.",
  "news": "Vijesti",
  "newsletter": "Newsletter",
  "newsletter_desc": "Pretplatite se za najnovije vijesti",
  "newsletter_only_subscribers": "Samo pretplatnici",
  "newsletter_subscribers": "Pretplatnici na newsletter",
  "next": "Dalje",
  "no": "Ne",
  "noAccount": "Nemate račun?",
  "no_articles": "Nema pronađenih članaka",
  "no_bookings": "Nema pronađenih rezervacija",
  "no_campaigns": "Nema kampanja",
  "no_data": "Nema dostupnih podataka",
  "no_items": "Nema pronađenih stavki",
  "no_linked_campaign": "Nema povezanih kampanja",
  "no_notifications": "Nema obavijesti",
  "no_results": "Nema rezultata",
  "no_scheduled_posts": "Još uvijek nema zakazanih objava",
  "no_sent_notifications": "Nema poslanih obavijesti",
  "none": "Nijedno",
  "note": "Napomena",
  "notification_body": "Tijelo obavijesti",
  "notification_title": "Naslov obavijesti",
  "notifications": "Obavijesti",
  "of": "od",
  "off": "Isključeno",
  "offline": "Offline",
  "on": "Uključeno",
  "one_time": "jednokratno",
  "online": "Online",
  "open_rate": "Stopa otvaranja",
  "optional": "Neobavezno",
  "options": "Opcije",
  "orContinueWith": "Ili nastavite s",
  "or_continue_with": "Ili nastavite s",
  "order": "Narudžba",
  "other": "Ostalo",
  "page": "Stranica",
  "part_time": "Skraćeno radno vrijeme",
  "password": "Lozinka",
  "paste": "Zalijepi",
  "pause": "Pauziraj",
  "payment_error": "Greška pri plaćanju",
  "payment_processing": "Obrada plaćanja...",
  "payment_success": "Plaćanje uspješno!",
  "payment_thank_you": "Hvala na vašoj kupnji!",
  "pending": "Na čekanju",
  "pending_approval": "Čeka se odobrenje",
  "per_month": "/mj",
  "per_page": "po stranici",
  "percentage": "Postotak",
  "performance": "Izvedba",
  "phone": "Telefon",
  "platforms": "Platforme",
  "politics": "Politika",
  "poll_results": "Rezultati",
  "poll_total_votes": "Ukupno glasova",
  "poll_vote": "Glasaj",
  "popular": "Popularno",
  "post_comment": "Objavi komentar",
  "post_error": "Pogreška pri objavi",
  "post_job": "Objavi oglas",
  "post_now": "Objavi sada",
  "powered_by": "Pokreće",
  "premium": "Premium",
  "preview": "Pregled",
  "previous": "Prethodno",
  "price": "Cijena",
  "privacy": "Privatnost",
  "privacy_title": "Pravila privatnosti",
  "proceed_to_payment": "Nastavi na plaćanje",
  "profile": "Profil",
  "profile_admin_access": "Brzi pristup administraciji",
  "profile_analytics": "Analitika",
  "profile_articles": "Članci",
  "profile_dashboard": "Nadzorna ploča",
  "profile_edit": "Uredi profil",
  "profile_verified": "Profil je verificiran!",
  "promo_success": "Promotivni kod uspješno primijenjen!",
  "promote_job": "Promoviraj posao",
  "publish": "Objavi",
  "published": "Objavljeno",
  "published_date": "Objavljeno",
  "push_notifications": "Push obavijesti",
  "read": "Pročitano",
  "read_more": "Čitaj više",
  "real_estate": "Nekretnine",
  "recent": "Najnovije",
  "recipes_add_first": "Dodaj svoj prvi recept",
  "recipes_browse_all": "Pregledaj sve recepte",
  "recipes_category": "Kategorija",
  "recipes_cook_time": "Vrijeme kuhanja",
  "recipes_easy": "Jednostavno",
  "recipes_featured": "Istaknuti Recepti",
  "recipes_filters": "Filtri",
  "recipes_ingredient": "Sastojak",
  "recipes_ingredients": "Sastojci",
  "recipes_instructions": "Upute",
  "recipes_latest": "Najnoviji Recepti",
  "recipes_most_popular": "Najpopularniji Recepti",
  "recipes_prep_time": "Vrijeme pripreme",
  "recipes_search": "Pretraži recepte...",
  "recipes_servings": "Porcije",
  "recipes_title": "Recepti",
  "recommended": "Preporučeno",
  "refresh": "Osvježi",
  "region": "Regija",
  "register": "Registracija",
  "reject": "Odbij",
  "rejected": "Odbijeno",
  "related_articles": "Povezani članci",
  "remote": "Rad od kuće",
  "remove": "Ukloni",
  "report": "Izvješće",
  "reports": "Izvješća",
  "reposting_rules_title": "Pravila repostanja",
  "required": "Obavezno",
  "reset": "Resetiraj",
  "restore": "Vrati",
  "results": "Rezultati",
  "resume": "Nastavi",
  "revision_restored": "Revizija vraćena!",
  "salary": "Plaća",
  "salary_max": "Najveća plaća",
  "salary_min": "Najmanja plaća",
  "save": "Spremi",
  "saved_jobs": "Spremljeni poslovi",
  "saved_successfully": "Uspješno spremljeno",
  "schedule": "Raspored",
  "scheduled": "Zakazano",
  "science": "Znanost",
  "search": "Pretraži...",
  "search_articles": "Pretraži članke...",
  "search_placeholder": "Pretraži...",
  "search_results_for": "Rezultati pretrage za",
  "seconds": "sekunde",
  "see_all": "Vidi sve",
  "select": "Odaberi",
  "select_all": "Odaberi sve",
  "select_format": "Odaberi format",
  "seller": "Prodavač",
  "send_campaign": "Pošalji kampanju",
  "sent": "Poslano",
  "sent_campaigns": "Poslane kampanje",
  "services": "Usluge",
  "settings": "Postavke",
  "share": "Podijeli",
  "showing": "Prikazujem",
  "signIn": "Prijava",
  "signOut": "Odjava",
  "site_name": "Croatia Times",
  "site_subtitle": "Hrvatska danas",
  "six_digit_code": "6-znamenkasti kod",
  "social_media": "Društveni mediji",
  "social_scheduler": "Planer društvenih objava",
  "sort": "Sortiraj",
  "sponsored_marketplace_title": "Sponzorirano tržište",
  "sports": "Sport",
  "stable": "Stabilno",
  "start": "Započni",
  "start_date": "Datum početka",
  "static_about_contact": "Za urednička pitanja, oglašavanje ili opće informacije, posjetite našu",
  "static_about_contact_page": "stranicu za kontakt",
  "static_about_contact_title": "Kontakt",
  "static_about_lead": "Croatia Times je neovisni informativni i uslužni portal koji donosi najnovije vijesti, analize, komentare i priče iz Hrvatske i regije. Dio smo medijske obitelji e-mina.eu, s istim timom i istim vrijednostima.",
  "static_about_mission": "Posvećeni smo pružanju točnog, pravovremenog i kvalitetnog novinarstva koje služi javnom interesu. Naš urednički tim sastavljen je od iskusnih novinara s dubokim razumijevanjem hrvatskih i regionalnih pitanja.",
  "static_about_mission_title": "Naša Misija",
  "static_about_publisher": "Liber Nostra d.o.o. je izdavač Croatia Timesa i e-mina.eu. Tvrtka se specijalizirala za digitalne medije i novinske portale s fokusom na hrvatsko tržište.",
  "static_about_publisher_title": "Izdavač",
  "static_about_standards": "Croatia Times se pridržava najviših novinarskih standarda. Provjeravamo točnost naših izvještaja, jasno označavamo komentare i analize, te brzo i transparentno ispravljamo pogreške.",
  "static_about_standards_title": "Urednički Standardi",
  "static_about_team": "Iza Croatia Timesa stoji tim iskusnih medijskih stručnjaka, novinara, urednika i tehničkih stručnjaka koji rade na razvoju platforme i kvaliteti sadržaja. Naš tim je isti onaj koji stoji iza uspješnog portala e-mina.eu - Međunarodna Novinska Agencija.",
  "static_about_team_title": "Tim",
  "static_about_title": "O nama - Croatia Times",
  "static_bug_description": "Opis greške",
  "static_bug_description_placeholder": "Opišite što se dogodilo i kako reproducirati problem...",
  "static_bug_intro": "Pronašli ste nešto što ne radi ispravno? Javite nam i mi ćemo to brzo popraviti.",
  "static_bug_page_url": "URL stranice (gdje se dogodila greška)",
  "static_bug_screenshot": "Snimka zaslona (neobavezno)",
  "static_bug_submit": "Pošalji prijavu greške",
  "static_bug_submitting": "Slanje...",
  "static_bug_thanks": "Hvala na vašem izvještaju! Istražit ćemo i riješiti problem.",
  "static_bug_title": "Prijavi grešku",
  "static_commenting_intro": "Pozdravljamo konstruktivnu raspravu. Da bismo održali našu sekciju komentara pozitivnom i produktivnom, pridržavajte se ovih pravila:",
  "static_commenting_login": "Za komentiranje, morate biti registrirani i prijavljeni u Croatia Times.",
  "static_commenting_rule_1": "Budite poštovani i pristojni prema drugim korisnicima i predmetima članaka",
  "static_commenting_rule_2": "Bez govora mržnje, rasizma, seksizma ili bilo kakve diskriminacije",
  "static_commenting_rule_3": "Bez spama, oglašavanja ili promotivnog sadržaja",
  "static_commenting_rule_4": "Bez dezinformacija ili širenja neprovjerenih tvrdnji",
  "static_commenting_rule_5": "Bez osobnih napada ili uznemiravanja",
  "static_commenting_rule_6": "Ostanite na temi i doprinosite razgovoru",
  "static_commenting_rule_7": "Bez osobnih ili povjerljivih informacija o trećim stranama",
  "static_commenting_title": "Pravila komentiranja",
  "static_commenting_violation": "Komentari koji krše ova pravila mogu biti uklonjeni bez obavijesti. Ponovljeni prekršitelji mogu biti trajno zabranjeni.",
  "static_contact_email": "Email",
  "static_contact_message": "Poruka",
  "static_contact_message_placeholder": "Vaša poruka...",
  "static_contact_name": "Ime",
  "static_contact_name_placeholder": "Vaše ime",
  "static_contact_send": "Pošalji Poruku",
  "static_contact_sending": "Slanje...",
  "static_contact_sent_desc": "Odgovorit ćemo vam u roku od 24 sata.",
  "static_contact_sent_title": "Poruka poslana!",
  "static_contact_subject": "Predmet",
  "static_contact_subject_placeholder": "Kako vam možemo pomoći?",
  "static_contact_title": "Kontaktirajte nas",
  "static_cookies_advertising_text": "Možemo koristiti Google AdSense kolačiće za prikaz relevantnih oglasa.",
  "static_cookies_advertising_title": "Oglašivački kolačići",
  "static_cookies_analytics_text": "Google Analytics nam pomaže razumjeti kako posjetitelji koriste našu stranicu. Podaci su anonimni kad god je to moguće.",
  "static_cookies_analytics_title": "Analitički kolačići",
  "static_cookies_managing_text": "Možete kontrolirati kolačiće putem postavki vašeg preglednika. Onemogućavanje nužnih kolačića može utjecati na funkcionalnost stranice.",
  "static_cookies_managing_title": "Upravljanje kolačićima",
  "static_cookies_necessary_text": "Potrebni su za funkcioniranje stranice (sesije prijave, postavke teme). Ne mogu se onemogućiti.",
  "static_cookies_necessary_title": "Neophodni kolačići",
  "static_cookies_title": "Politika kolačića",
  "static_cookies_types_title": "Vrste kolačića koje koristimo",
  "static_cookies_what_text": "Kolačići su male tekstualne datoteke postavljene na vaš uređaj kada posjetite web stranicu. Pomažu stranici da zapamti vaše postavke i razumije kako je koristite.",
  "static_cookies_what_title": "Što su kolačići",
  "static_imprint_ads_email": "Email (oglašavanje):",
  "static_imprint_ai_notice": "Neki sadržaji su generirani korištenjem AI tehnologije. Prijavite pogreške ili neprimjeren sadržaj na",
  "static_imprint_contact": "Kontakt",
  "static_imprint_copyright": "Autorska prava",
  "static_imprint_copyright_text": "Sav sadržaj objavljen na Croatia Timesu zaštićen je autorskim pravom. Liber Nostra d.o.o. zadržava sva prava na tekst, slike i multimedijalni sadržaj objavljen na ovoj stranici. Detaljne informacije o pravilima ponovno objavljivanja sadržaja dostupne su na",
  "static_imprint_ct_desc": "Informativni i uslužni portal Croatia Times",
  "static_imprint_disclaimer": "Izjava o odricanju odgovornosti",
  "static_imprint_disclaimer_text": "Unatoč pažljivoj kontroli sadržaja, ne preuzimamo odgovornost za vanjske poveznice. Njihovi operateri isključivo su odgovorni za njihov sadržaj.",
  "static_imprint_editorial_email": "Email (urednički):",
  "static_imprint_emina_desc": "Međunarodna Novinska Agencija",
  "static_imprint_general_email": "Email (opći upiti):",
  "static_imprint_last_updated": "Posljednje ažuriranje: veljača 2026",
  "static_imprint_or_via": "ili putem naše",
  "static_imprint_publisher": "Izdavač",
  "static_imprint_registered": "Registrirano u Republici Hrvatskoj",
  "static_imprint_reposting_page": "stranici Pravila ponovno objavljivanja",
  "static_imprint_responsible": "Odgovorni za Sadržaj",
  "static_imprint_responsible_text": "Urednički tim Croatia Times / Liber Nostra d.o.o.",
  "static_imprint_title": "Impresum",
  "static_imprint_websites": "Web stranice",
  "static_privacy_controller": "Voditelj obrade podataka: Liber Nostra d.o.o.",
  "static_privacy_cookies_text": "Koristimo kolačiće za funkcionalnost i analitiku. Pogledajte našu Politiku kolačića za detalje.",
  "static_privacy_cookies_title": "Kolačići",
  "static_privacy_data_text": "Prikupljamo podatke koje nam izravno pružate (ime, email prilikom registracije), podatke o korištenju (posjećene stranice, pročitani članci), te tehničke podatke (IP adresa, tip preglednika).",
  "static_privacy_data_title": "Podaci koje prikupljamo",
  "static_privacy_last_updated": "Posljednje ažuriranje: siječanj 2026",
  "static_privacy_lead": "Croatia Times poštuje vašu privatnost i predan je zaštiti vaših osobnih podataka.",
  "static_privacy_retention_text": "Zadržavamo vaše podatke dok god je vaš račun aktivan ili koliko je potrebno za pravne svrhe.",
  "static_privacy_retention_title": "Zadržavanje podataka",
  "static_privacy_rights_text": "Imate pravo pristupiti, ispraviti ili izbrisati svoje osobne podatke. Kontaktirajte nas na",
  "static_privacy_rights_title": "Vaša prava",
  "static_privacy_title": "Pravila Privatnosti",
  "static_privacy_usage_text": "Koristimo vaše podatke za pružanje naše usluge vijesti, personalizaciju vašeg iskustva, slanje biltena (uz vaš pristanak) i poboljšanje naše platforme.",
  "static_privacy_usage_title": "Kako koristimo vaše podatke",
  "static_reposting_copyright_text": "Sav sadržaj objavljen na Croatia Times zaštićen je autorskim pravima. Liber Nostra d.o.o. zadržava sva prava na tekstove, slike i multimediju objavljene na ovoj web stranici.",
  "static_reposting_copyright_title": "Autorska prava",
  "static_reposting_permission_text": "Za dopuštenje za ponovno tiskanje sadržaja, kontaktirajte nas na",
  "static_reposting_permission_title": "Zahtjevi za dopuštenje",
  "static_reposting_permitted_text": "Možete dijeliti poveznice na naše članke na društvenim mrežama i drugim platformama. Kratki citati (do 2 odlomka) mogu se koristiti uz jasno navođenje izvora i poveznicu natrag na izvorni članak.",
  "static_reposting_permitted_title": "Dopuštena uporaba",
  "static_reposting_prohibited_text": "Potpuno ponovno tiskanje članaka bez pismenog dopuštenja je zabranjeno. Slike se ne smiju reproducirati bez dopuštenja. Automatsko preuzimanje sadržaja strogo je zabranjeno.",
  "static_reposting_prohibited_title": "Zabranjena uporaba",
  "static_reposting_title": "Pravila ponovnog objavljivanja",
  "static_submit_news_details": "Detalji priče",
  "static_submit_news_details_placeholder": "Opišite vijest...",
  "static_submit_news_file_limit_error": "Datoteka premašuje ograničenje od",
  "static_submit_news_headline": "Naslov vijesti",
  "static_submit_news_intro": "Imate vijest? Pošaljite je ovdje i naš urednički tim će je pregledati.",
  "static_submit_news_limit": "Prihvaćamo fotografije i videozapise do",
  "static_submit_news_photos": "Fotografije / Video (do",
  "static_submit_news_send": "Pošalji vijest",
  "static_submit_news_choose_file": "Odaberi datoteku",
  "static_submit_news_no_file": "Nijedna datoteka nije odabrana",
  "static_submit_news_sending": "Slanje...",
  "static_submit_news_source": "Izvor / Referenca (neobavezno)",
  "static_submit_news_source_placeholder": "URL ili referenca",
  "static_submit_news_thanks": "Hvala vam na vašem unosu! Naš tim će ga uskoro pregledati.",
  "static_submit_news_title": "Pošaljite svoju vijest",
  "static_submit_news_your_name": "Vaše ime",
  "status": "Status",
  "stop": "Zaustavi",
  "submit": "Pošalji",
  "submitNews": "Pošalji vijest",
  "submit_bug_title": "Prijavi grešku",
  "submit_news": "Pošalji vijest",
  "submit_news_title": "Pošalji vijest",
  "subscribe": "Pretplata",
  "subscription": "Pretplata",
  "subscription_title": "Pretplatnički planovi",
  "success": "Uspjeh",
  "support": "Podrška",
  "tablet": "Tablet",
  "tags": "Oznake",
  "target_impressions": "Ciljane impresije",
  "technology": "Tehnologija",
  "template": "Predložak",
  "templates": "Predlošci",
  "terms": "Uvjeti",
  "thank_you": "Hvala",
  "this_month": "Ovaj mjesec",
  "this_week": "Ovaj tjedan",
  "this_year": "Ova godina",
  "tip": "Savjet",
  "title": "Naslov",
  "to": "Do",
  "today": "Danas",
  "total": "Ukupno",
  "translate_all": "Prevedi sve",
  "translation_status": "Status prijevoda",
  "translations": "Prijevodi",
  "travel": "Putovanja",
  "trending": "Trendovi",
  "try_again": "Pokušajte ponovo",
  "twitter": "Twitter",
  "two_factor_auth": "Dvofaktorska autentifikacija",
  "type": "Tip",
  "ugc_submit": "Pošaljite sadržaj",
  "ugc_title": "Portal građanskog novinarstva",
  "unique_clicks": "Jedinstveni klikovi",
  "unique_opens": "Jedinstvena otvaranja",
  "unknown": "Nepoznato",
  "unpublish": "Poništi objavu",
  "unread": "Nepročitano",
  "update": "Ažuriraj",
  "updated_successfully": "Uspješno ažurirano",
  "upgrade": "Nadogradi",
  "upload": "Prenesi",
  "users": "Korisnici",
  "vehicles": "Vozila",
  "verification_code_sent": "Verifikacijski kod poslan na vašu e-mail adresu!",
  "version": "Verzija",
  "vibeposao": "Times Posao",
  "view": "Pogledaj",
  "view_all": "Pregledaj sve",
  "views": "Pregleda",
  "warning": "Upozorenje",
  "welcome": "Dobrodošli",
  "wish_roles": "Traženi poslovi",
  "working_hours_saved": "Radno vrijeme je spremljeno!",
  "world": "Svijet",
  "write_new_article": "Napiši novi članak",
  "yes": "Da",
  "yesterday": "Jučer",
  "your_bookings": "Vase rezervacije",
  "youtube": "YouTube",

  // === TIMES BRANDS & COUNTY MAP ===
  "times_brands_subtitle": "Istrazite sve Times usluge",
  "county_map_subtitle": "Odaberite zupaniju za vijesti iz vaseg kraja",
  "no_county_articles": "Nema clanaka za odabranu zupaniju."
}
